import { Stack } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import { TFunction } from 'i18next';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

interface DepositCheckConfimableViewProps {
  errors: string[];
  translatedText: TFunction<'rdc', undefined>;
  isLoading: boolean;
  handleReviewCheckAction: () => void;
  handleConfirmCheckDepositAction: () => void;
}

const DepositCheckConfirmableView = ({
  errors,
  translatedText,
  isLoading,
  handleReviewCheckAction,
  handleConfirmCheckDepositAction,
}: DepositCheckConfimableViewProps) => {
  const { outcome } = rdcStrings;

  useViewDidFocusScreenAnalyticsEvent({
    key: 'checkDepositError',
  });

  return (
    <View style={baseStyles.container} accessible>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Warning}
        messageHeadline={translatedText(
          'outcome.confirmable.title',
          outcome.confirmable.title,
        )}
        content={<ContentList contentList={errors} />}
        primaryButton={{
          title: translatedText(
            'confirmable.buttons.reviewCheck',
            outcome.confirmable.buttons.reviewCheck,
          ),
          onPress: handleReviewCheckAction,
          analytics: { analyticsId: 'rdcCheckReviewClicked' },
        }}
        secondaryButton={{
          title: translatedText(
            'confirmable.buttons.sendCheckAsIs',
            outcome.confirmable.buttons.sendCheckAsIs,
          ),
          isLoading: isLoading,
          analytics: {
            analyticsId: 'rdcCheckSubmitted',
            customAttributes: { source_name: 'check_deposit_error' },
          },
          onPress: handleConfirmCheckDepositAction,
        }}
      />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default DepositCheckConfirmableView;
